var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
// Mappings between badge's sizes and variants, and design tokens
var sizeMap = {
    small: {
        fontSize: '10px',
        sizing: '14px',
    },
    medium: {
        fontSize: tokens.fontSizes.small,
        sizing: '18px',
    },
    large: {
        fontSize: tokens.fontSizes.medium,
        sizing: '20px',
    },
};
var variantMap = {
    green: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.green,
    },
    navy: {
        color: tokens.colors.white,
        backgroundColor: tokens.colors.navy,
    },
    white: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.white,
    },
    red: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.red,
    },
    orange: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.orange,
    },
    yellow: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.yellow,
    },
    blue: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.blue,
    },
    purple: {
        color: tokens.colors.white,
        backgroundColor: tokens.colors.purple,
    },
    pink: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.pink,
    },
    grey: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.greyMedium,
    },
    greyLight: {
        color: '#626D79',
        backgroundColor: tokens.colors.greyLight,
    },
};
var baseBadgeStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  text-transform: uppercase;\n  border-radius: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  letter-spacing: 0.5px;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  text-transform: uppercase;\n  border-radius: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  letter-spacing: 0.5px;\n"])), tokens.fontFamilies.sansSerif, tokens.fontWeights.bold, tokens.lineHeights.tight, tokens.borderRadius.medium, tokens.spacing.xsmall, tokens.spacing.xsmall);
export function badgeStyle(_a) {
    var variant = _a.variant, size = _a.size;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    color: ", ";\n    background-color: ", ";\n    font-size: ", ";\n    height: ", ";\n  "], ["\n    ", "\n    color: ", ";\n    background-color: ", ";\n    font-size: ", ";\n    height: ", ";\n  "])), baseBadgeStyle, variantMap[variant].color, variantMap[variant].backgroundColor, sizeMap[size].fontSize, sizeMap[size].sizing);
}
export function innerContentStyle() {
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-width: 164px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  "], ["\n    max-width: 164px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  "])));
}
var templateObject_1, templateObject_2, templateObject_3;
